import { render, staticRenderFns } from "./pt-sp-create.vue?vue&type=template&id=78fe98a3&"
import script from "./pt-sp-create.vue?vue&type=script&lang=js&"
export * from "./pt-sp-create.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports